import "core-js/modules/es6.object.create";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import e, { Component as t } from "react";
import o from "prop-types";

function n(e, t) {
  for (var o = 0; o < t.length; o++) {
    var n = t[o];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function r(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}

function a() {
  return (a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var n in o) {
        Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function s(e, t) {
  return (s = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function i() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function c(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function y(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? c(e) : t;
}

var p = {
  "overlay-wrapper": "styles_overlay-wrapper__O0Zm8",
  backdrop: "styles_backdrop__2LNQS",
  "overlay-content": "styles_overlay-content__1qZR_",
  "with-outline": "styles_with-outline__ogLFa",
  "overlay-close": "styles_overlay-close__3e1ke",
  "overlay-open": "styles_overlay-open__3VYiy",
  "overlay-opening": "styles_overlay-opening__1xWk2",
  fadeIn: "styles_fadeIn__N7HUl",
  "overlay-closed": "styles_overlay-closed__DwoRv",
  "overlay-hidden": "styles_overlay-hidden__3xj42",
  "overlay-closing": "styles_overlay-closing__h8wXL",
  "scroll-lock": "styles_scroll-lock__1ANm6",
  fadeOut: "styles_fadeOut__1FkJy"
};
!function (e, t) {
  void 0 === t && (t = {});
  var o = t.insertAt;

  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
        r = document.createElement("style");
    r.type = "text/css", "top" === o && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }
}(".styles_overlay-wrapper__O0Zm8 {\n  top: var(--top, 0);\n  bottom: 0;\n  left: 0;\n  right: 0;\n  position: fixed;\n  overflow: auto;\n  display: flex;\n  transition: opacity 0.5s;\n  z-index: 999; }\n  .styles_overlay-wrapper__O0Zm8 .styles_backdrop__2LNQS {\n    top: var(--top, 0);\n    bottom: 0;\n    left: 0;\n    right: 0;\n    position: fixed;\n    overflow: auto;\n    display: flex;\n    background-color: rgba(50, 50, 50, 0.88);\n    padding: 2em 0; }\n  .styles_overlay-wrapper__O0Zm8 .styles_overlay-content__1qZR_ {\n    padding: 2em;\n    background-color: white;\n    max-width: 600px;\n    position: relative;\n    margin: auto;\n    transition: opacity 0.85s; }\n    .styles_overlay-wrapper__O0Zm8 .styles_overlay-content__1qZR_.styles_with-outline__ogLFa:focus {\n      outline: 2px solid #0366d6;\n      outline-offset: 2px; }\n    .styles_overlay-wrapper__O0Zm8 .styles_overlay-content__1qZR_ .styles_overlay-close__3e1ke {\n      top: 0;\n      right: 0;\n      position: absolute;\n      cursor: pointer;\n      width: 45px;\n      height: 45px;\n      display: flex;\n      justify-content: center;\n      align-items: center; }\n  .styles_overlay-wrapper__O0Zm8.styles_overlay-open__3VYiy {\n    opacity: 1; }\n  .styles_overlay-wrapper__O0Zm8.styles_overlay-opening__1xWk2 {\n    animation: styles_fadeIn__N7HUl 0.5s; }\n  .styles_overlay-wrapper__O0Zm8.styles_overlay-closed__DwoRv, .styles_overlay-wrapper__O0Zm8.styles_overlay-hidden__3xj42 {\n    display: none;\n    opacity: 0; }\n  .styles_overlay-wrapper__O0Zm8.styles_overlay-closing__h8wXL {\n    opacity: 0; }\n\n.styles_scroll-lock__1ANm6 {\n  overflow: hidden; }\n\n@keyframes styles_fadeIn__N7HUl {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes styles_fadeOut__1FkJy {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n");

var u = function u(t) {
  var o = t.overlayState,
      n = t.clickDismiss,
      r = void 0 === n || n,
      a = t.closeOverlay,
      l = o === v.OPENING || o === v.CLOSING;
  return e.createElement("div", {
    className: p.backdrop,
    "data-comp": "backdrop",
    onClick: function onClick(e) {
      var t = e.target.dataset && "backdrop" === e.target.dataset.comp;
      r && !l && t && a(), e.stopPropagation();
    }
  }, t.children);
};

u.propTypes = {
  overlayState: o.string.isRequired,
  clickDismiss: o.bool,
  closeOverlay: o.func,
  children: o.element
};

var v = {
  OPEN: "OPEN",
  OPENING: "OPENING",
  HIDDEN: "HIDDEN",
  CLOSED: "CLOSED",
  CLOSING: "CLOSING"
},
    f = function f(e) {
  var t = document.getElementsByTagName("body")[0],
      o = p["scroll-lock"];
  e ? t.classList.contains(o) || t.classList.add(o) : Object.values(_.tracker).filter(Boolean).length || t.classList.remove(o);
},
    d = function d(e) {
  return e && e.focus();
},
    _ = function (o) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && s(e, t);
  }(w, t);

  var _,
      h,
      O,
      m,
      g = (_ = w, function () {
    var e,
        t = l(_);

    if (i()) {
      var o = l(this).constructor;
      e = Reflect.construct(t, arguments, o);
    } else e = t.apply(this, arguments);

    return y(this, e);
  });

  function w(t) {
    var o;
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, w), r(c(o = g.call(this, t)), "updateOverlayTracker", function () {
      w.tracker[o.state.overlayId] = o.props.isOpen;
    }), r(c(o), "keyPress", function (e) {
      if (27 === (e.keyCode ? e.keyCode : e.which)) {
        var t = o.props,
            n = t.isOpen,
            r = t.closeOverlay;
        n && r(), e.stopPropagation();
      }
    }), r(c(o), "shiftFocusToOverlay", function () {
      var e = o.ref.current;
      d(e);
    }), r(c(o), "shiftFocusToEle", function (e) {
      d(e), f(!1);
    }), r(c(o), "handleCloseOverlay", function (e) {
      e.preventDefault(), o.props.closeOverlay && o.props.closeOverlay();
    }), o.state = {
      overlayState: v.HIDDEN,
      prevState: t.isOpen,
      initiator: null,
      overlayId: w.getNewOverlayId()
    }, o.ref = e.createRef(), o;
  }

  return h = w, m = [{
    key: "getNewOverlayId",
    value: function value() {
      return this.trackerId++, "overlay-".concat(this.trackerId);
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function value(e, t) {
      var o = e.isOpen,
          n = e.configs,
          r = (n = void 0 === n ? {} : n).animate,
          a = void 0 === r || r;
      return o === t.prevState ? null : o ? (f(!0), {
        overlayState: a ? v.OPENING : v.OPEN,
        prevState: o,
        initiator: document.activeElement
      }) : {
        overlayState: a ? v.CLOSING : v.CLOSED,
        prevState: o
      };
    }
  }], (O = [{
    key: "componentDidMount",
    value: function value() {
      this.updateOverlayTracker();
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      var e = this,
          t = (this.props.configs || {}).animate,
          o = void 0 === t || t,
          n = this.state,
          r = n.overlayState,
          a = n.initiator;
      this.updateOverlayTracker(), o ? r === v.OPENING ? (this.shiftFocusToOverlay(), setTimeout(function () {
        e.setState({
          overlayState: v.OPEN
        });
      }, 500)) : r === v.CLOSING && (this.shiftFocusToEle(a), setTimeout(function () {
        e.setState({
          overlayState: v.CLOSED
        });
      }, 500)) : r === v.OPEN ? this.shiftFocusToOverlay() : this.shiftFocusToEle(a);
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          o = this.props,
          n = o.children,
          r = o.isOpen,
          l = o.closeOverlay,
          s = o.configs,
          i = void 0 === s ? {} : s,
          c = (i.animate, i.top),
          y = void 0 === c ? 0 : c,
          f = i.contentClass,
          d = void 0 === f ? "" : f,
          _ = i.clickDismiss,
          h = void 0 === _ || _,
          O = i.escapeDismiss,
          m = void 0 === O || O,
          g = i.focusOutline,
          w = void 0 !== g && g,
          k = i.showCloseIcon,
          b = void 0 === k || k,
          N = this.state.overlayState,
          E = {
        className: [p["overlay-wrapper"], N === v.HIDDEN ? p["overlay-hidden"] : "", N === v.OPEN ? p["overlay-open"] : "", N === v.OPENING ? p["overlay-opening"] : "", N === v.CLOSING ? p["overlay-closing"] : "", N === v.CLOSED ? p["overlay-closed"] : ""].filter(Boolean).join(" "),
        onKeyPress: m ? function (e) {
          return t.keyPress(e);
        } : void 0,
        onKeyDown: m ? function (e) {
          return t.keyPress(e);
        } : void 0,
        "aria-hidden": !r
      },
          S = {
        className: [p["overlay-content"], w ? p["with-outline"] : "", d].filter(Boolean).join(" "),
        tabIndex: 0,
        role: "dialog"
      },
          I = {
        "--top": y
      };
      return e.createElement("div", a({}, E, {
        style: I
      }), e.createElement(u, {
        overlayState: N,
        clickDismiss: h,
        closeOverlay: l
      }, e.createElement("div", a({
        ref: this.ref
      }, S), l && b ? e.createElement("div", {
        className: p["overlay-close"],
        role: "button",
        tabIndex: "0",
        onClick: l,
        onKeyPress: this.handleCloseOverlay,
        dangerouslySetInnerHTML: {
          __html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="36px" height="36px"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
        }
      }) : null, n)));
    }
  }]) && n(h.prototype, O), m && n(h, m), w;
}();

r(_, "tracker", {}), r(_, "trackerId", 0), _.propTypes = {
  isOpen: o.bool.isRequired,
  children: o.any,
  configs: o.object,
  closeOverlay: o.func,
  showCloseIcon: o.bool
};
export default _;
export { v as STATES };